// Chakra imports
import { Box } from '@chakra-ui/react';
// Layout components
import Sidebar from 'components/sidebar/Sidebar.js';
import MobileMenuButton from 'components/sidebar/MobileMenuButton.js';
import { SidebarContext } from 'contexts/SidebarContext';
import React, { useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useDynamicRoutes } from 'hooks/useDynamicRoutes';
import OnboardingOverlay from 'components/onboarding/OnboardingOverlay';
import SubscriptionChecker from 'components/billing/SubscriptionChecker';

// Custom Chakra theme
export default function Dashboard(props) {
  const { ...rest } = props;
  const location = useLocation();
  const { routes } = useDynamicRoutes();
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  // functions for changing the states from components
  const getRoute = () => {
    return location.pathname !== '/admin/full-screen-maps';
  };
  const getRoutes = (routes) => {
    return routes.map((route, key) => {
      if (route.layout === '/admin' && !route.navigationOnly) {
        return (
          <Route path={`${route.path}`} element={route.component} key={key} />
        );
      }
      if (route.collapse) {
        return getRoutes(route.items);
      } else if (route.category) {
        return getRoutes(route.items);
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = 'ltr';
  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Sidebar routes={routes} display="none" {...rest} />
          <MobileMenuButton routes={routes} />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            maxWidth={{ base: '100%', xl: 'calc( 100% - 290px )' }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            {getRoute() ? (
              <Box
                mx="auto"
                pt={{ base: '15px', md: '20px' }}
                px={{ base: '20px', md: '30px' }}
                pb={{ base: '20px', md: '30px' }}
                minH="100vh"
              >
                <Routes>
                  {getRoutes(routes)}
                  <Route
                    path="/"
                    element={<Navigate to="/admin/default" replace />}
                  />
                </Routes>
              </Box>
            ) : null}
          </Box>
        </SidebarContext.Provider>
      </Box>
      
      {/* Onboarding Overlay */}
      <OnboardingOverlay />
      
      {/* Subscription Checker */}
      <SubscriptionChecker />
    </Box>
  );
}
